import '../jquery'

// LEGACY JS for DNS

window.init_dns_value_placeholder = function init_dns_value_placeholder() {
  var kind = $("option:selected", $("#domain_record_kind")).text();
  switch (kind) {
    case 'A':
      $('#domain_record_value').attr('placeholder', $('#domain_record_value').data("placeholder-ipv4"));
      break;
    case 'AAAA':
      $('#domain_record_value').attr('placeholder', $('#domain_record_value').data("placeholder-ipv6"));
      break;
    case 'CNAME':
    case 'PTR':
      $('#domain_record_value').attr('placeholder', $('#domain_record_value').data("placeholder-domain-name"));
      break;
    case 'SPF':
      $('#dns-spf').show();
      $('#dns-other').hide();
      break;
    case 'NS':
      $('#domain_record_value').attr('placeholder', $('#domain_record_value').data("placeholder-ns"));
      break;
    default:
      $('#domain_record_value').attr('placeholder', $('#domain_record_value').data("placeholder-other"));
  }
}

function enable_or_disable_ns_ip_field(input) {
  var id = input.attr('id').replace('_value', '_ip_address');
  var ip_address_input = $('#' + id);
  if (input.val().endsWith($('#name_servers_domain_name').text())) {
    ip_address_input.prop('disabled', false);
  } else {
    ip_address_input.prop('disabled', true);
    ip_address_input.val('');
  }
}

$(document).ready(function () {
  init_dns_value_placeholder();
  $(document).on('change', '.domain_nameservers_value input', function () {
    enable_or_disable_ns_ip_field($(this));
  });

  $(document).on('keypress', '.domain_nameservers_value input', function () {
    enable_or_disable_ns_ip_field($(this));
  });

  $(document).on('keyup', '.domain_nameservers_value input', function () {
    enable_or_disable_ns_ip_field($(this));
  });

  $(document).on('focus', '.domain_nameservers_value input', function () {
    enable_or_disable_ns_ip_field($(this));
  });

  $(document).on('blur', '.domain_nameservers_value input', function () {
    enable_or_disable_ns_ip_field($(this));
  });

  $(document).on('change', '#domain_record_kind', function () {
    $('#dns-spf').hide();
    $('#dns-other').show();
    init_dns_value_placeholder();

  });

  // $(document).on('change', '.search-form :input', function () {
  //     $('.search-form').trigger('submit.rails');
  // });
  //
  // $(document).on('keypress', '.search-form :input', function () {
  //     $('.search-form').trigger('submit.rails');
  // });

  $(document).on('focus', '#domain_record_value', function () {
    var kind = $("option:selected", $("#domain_record_kind")).text();
    if (kind === 'TXT') {
      window.modal.getOrCreateInstance($('#domain_record_kind_txt_modal')).show();
    } else if (kind === 'MX') {
      window.modal.getOrCreateInstance($('#domain_record_kind_mx_modal')).show();
    } else if (kind === 'SRV') {
      window.modal.getOrCreateInstance($('#domain_record_kind_srv_modal')).show();
    } else if (kind === 'LOC') {
      window.modal.getOrCreateInstance($('#domain_record_kind_loc_modal')).show();
    } else if (kind === 'CAA') {
      window.modal.getOrCreateInstance($('#domain_record_kind_caa_modal')).show();
    }
  });

  $('#domain_record_kind_txt_modal').on('shown.bs.modal', function (e) {
    $('#domain_record_value_txt').focus();
  });

  $('#domain_record_kind_mx_modal').on('shown.bs.modal', function (e) {
    $('#domain_record_value_mx').focus();
  });

  $('#domain_record_kind_srv_modal').on('shown.bs.modal', function (e) {
    $('#domain_record_service').focus();
  });

  $(document).on('turbo:load', function () {
    $('#change_ns').click(function (event) {
      event.preventDefault();
      $('#change_ns_container').show();
      $('#default_ns_table').hide();
    });
  });
  
  set_ns_field_visibility();

  $('#domain_ns_type').change(function () {
    set_ns_field_visibility();
  });


  function set_ns_field_visibility() {
    var kind = $('#domain_ns_type').val();
    switch (kind) {
      case 'default_ns':
        $('.add_fields_link').hide();
        $('#name_servers_form').hide();
        break;
      case 'cpanel_ns':
        $('.add_fields_link').hide();
        $('#name_servers_form').hide();
        break;
      case 'custom_ns':
        $('.add_fields_link').show();
        $('#name_servers_form').show();
        break;
      case 'old_latnet_ns':
        $('.add_fields_link').hide();
        $('#name_servers_form').hide();
        break;
    }
  }


});
